import { motion } from "framer-motion";

const INDUSTRIES = [
  { name: "Shipbuilding", img: "https://laser-machines.com/images/app_01.webp" },
  { name: "Structural Steel", img: "https://laser-machines.com/images/app_02.webp" },
  { name: "Heavy Machinery", img: "https://laser-machines.com/images/app_03.webp" },
  { name: "Advertising", img: "https://laser-machines.com/images/app_04.webp" },
  { name: "Automotive", img: "https://laser-machines.com/images/app_05.webp" },
  { name: "Construction", img: "https://laser-machines.com/images/app_06.webp" },
  { name: "Furniture", img: "https://laser-machines.com/images/app_07.webp" },
  { name: "Medical", img: "https://laser-machines.com/images/app_08.webp" },
  { name: "Railway", img: "https://laser-machines.com/images/app_09.webp" },
  { name: "Aircraft", img: "https://laser-machines.com/images/app_11.webp" },
];

export default function Industries() {
  return (
    <section id="solutions" data-testid="industries-section" className="bg-white">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-8 lg:py-20">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-laser">Industries</p>
            <h2 className="mt-3 text-3xl font-bold leading-tight text-[#222] sm:text-4xl" data-testid="industries-heading">
              Industrial laser systems for precise cutting and welding
            </h2>
          </div>
          <div className="flex flex-col justify-end">
            <p className="text-sm leading-relaxed text-muted-foreground">
              Our laser series is engineered for precision and performance, offering solutions that cater to diverse industrial needs. Whether it involves intricate cutting tasks or welding applications, our laser equipment is designed to enhance production efficiency and elevate product quality.
            </p>
            <a href="#contact" data-testid="industries-more-link" className="mt-4 text-xs font-semibold uppercase tracking-[0.15em] text-laser hover:text-laser-hover">
              View More &rarr;
            </a>
          </div>
        </div>
        <div className="mt-12 grid grid-cols-2 gap-6 sm:grid-cols-3 lg:grid-cols-5">
          {INDUSTRIES.map((item, i) => (
            <motion.div
              key={item.name}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.4, delay: (i % 5) * 0.06 }}
              className="group flex flex-col items-center text-center"
              data-testid={`industry-card-${item.name.toLowerCase().replace(/\s/g, "-")}`}
            >
              <div className="h-28 w-28 overflow-hidden rounded-full border-4 border-[#F0F1F3] transition-colors duration-200 group-hover:border-laser">
                <img src={item.img} alt={item.name} loading="lazy" className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-110" />
              </div>
              <div className="mt-3 text-[13px] leading-snug text-muted-foreground">
                Fiber laser solution for
                <div className="text-sm font-semibold text-[#333]">{item.name}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
